/* Formatting parity with the server contract: raw numbers in, display out. */

export const money = (n) =>
  n == null ? "–" :
  Math.abs(n) >= 1e9 ? `$${(n / 1e9).toFixed(2)}B` :
  Math.abs(n) >= 1e6 ? `$${(n / 1e6).toFixed(2)}M` :
  Math.abs(n) >= 1e3 ? `$${Math.round(n / 1e3)}K` :
  `$${Math.round(n)}`;

export const moneyC = (n) =>
  n == null ? "–" : `$${Math.round(n).toLocaleString("en-US")}`;

export const pct = (n) => `${n > 0 ? "+" : ""}${(+n).toFixed(1)}%`;

export const int = (n) => (n == null ? "–" : Math.round(n).toLocaleString("en-US"));

const SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const LONG = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

/** "2026-03" -> "March 2026" (or "Mar 2026" when short) */
export function monthLabel(ym, short = false) {
  if (!ym) return "–";
  const [y, m] = ym.split("-").map(Number);
  return `${(short ? SHORT : LONG)[m - 1] || ""} ${y}`;
}

/** "2026-03" -> "Mar" for chart axes */
export const monthShort = (ym) => SHORT[Number(ym?.split("-")[1]) - 1] || "";

/** Title-case ALL-CAPS dataset strings: "THE DEAD RABBIT" -> "The Dead Rabbit" */
export function titleCase(s) {
  if (!s) return s;
  return String(s).toLowerCase().replace(/(^|[\s\-'/(.])([a-z])/g, (_, p, c) => p + c.toUpperCase())
    .replace(/\b(Llc|Lp|Llp|Inc|Bbq|Tx|Ii|Iii|Iv)\b/g, (m) => m.toUpperCase());
}

/** Deterministic seeded series for decorative sparklines / sample trends.
 * The prototype's trends are seeded 12-month series with the last point =
 * actual; this mirrors that so visuals are stable across renders. */
export function seededSeries(key, endValue, points = 10, drift = 0.04) {
  let a = [...String(key)].reduce((h, c) => (Math.imul(h, 31) + c.charCodeAt(0)) | 0, 7) >>> 0;
  const rnd = () => {
    a |= 0; a = (a + 0x6d2b79f5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  const out = [endValue];
  let v = endValue;
  for (let i = 1; i < points; i++) {
    v = v / (1 + (drift * (rnd() - 0.35)));
    out.unshift(v);
  }
  return out;
}
